import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import messages from './lang'
import VueI18n from 'vue-i18n'
import axios from 'axios'
import './assets/normalize.less'
// import Cookie from 'js-cookie'
import './utils/filters'
import './plugins/vant'
import './plugins/element-ui'
import './assets/common.less'
import 'element-ui/lib/theme-chalk/index.css'
import {handleErr} from '@/utils'
import VueClipBoard from 'vue-clipboard2'

Vue.config.productionTip = false

global.BUS = new Vue()
global.router = router

// i18配置
const langKey = 'zh-cn'
Vue.use(VueI18n)
const i18n = new VueI18n({
  locale: langKey,
	messages
})
let api = '/'
if (process.env.NODE_ENV === 'development') {
  axios.defaults.withCredentials = true
  api = '/api'
}
// axios配置
axios.defaults.baseURL = api
axios.defaults.headers['X-PD-URI'] = 'api'
Vue.prototype.$axios = axios

Vue.config.lang = langKey
global.__helpers__ = global.__helpers__ || {}
document.title = i18n.t('app.title.webTitle')
Vue.prototype.$handleErr = handleErr
Vue.prototype.$store = store
Vue.use(VueClipBoard)
new Vue({
  router,
  store,
  i18n,
  render: h => h(App)
}).$mount('#app')
